module.exports = __webpack_public_path__ + "assets/6d75f1083c463152d9f695e0a252567a.svg";